/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';

const ProspectAdditionalInfo = ({ text }) => {
  const additionalTextColor = 'silver';

  return (
    <>
      <div style={{ lineHeight: '16px' }}>
        <span style={{ color: `${additionalTextColor}` }}>
          {text}
        </span>
      </div>
    </>
  );
};

export default ProspectAdditionalInfo;

ProspectAdditionalInfo.propTypes = {
  text: PropTypes.string.isRequired,
};
